import { render } from "./user.need.monitor.vue?vue&type=template&id=6c603db8"
import script from "./user.need.monitor.vue?vue&type=script&lang=js"
export * from "./user.need.monitor.vue?vue&type=script&lang=js"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__